/**
 *
 * Update Wire Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import { NAMESPACE } from './constants';

const selectService = (state) => state ? state[NAMESPACE] : {};

const selectStatus = createSelector(selectService, (service) => service.status);

const selectResult = createSelector(selectService, (service) => service.result);

const selectError = createSelector(selectService, (service) => service.error);

export {
  selectStatus,
  selectResult,
  selectError,
};



// WEBPACK FOOTER //
// ./src/services/suspendWire/selectors.js